/**
 * EmptyState — shown when a list is empty.
 *
 * The goal is to not just say "no staff" but to show the user exactly
 * what they should do next. Every empty state has a primary action.
 */
export function EmptyState({ icon, title, body, action }) {
  return (
    <div className="empty-state">
      {icon && (
        <div className="empty-state-icon" aria-hidden="true">
          {icon}
        </div>
      )}
      {title && <h2 className="empty-state-title">{title}</h2>}
      {body && <p className="empty-state-body">{body}</p>}
      {action}
    </div>
  );
}
